// MUI theme transition duration for entering screen (sidebar collapse/expand, drawer animations)
export const ENTERING_SCREEN_MS = 225

// Debounce for ResizeObserver callbacks during CSS transitions — fires once after the transition
// completes rather than on every animation frame (~60x per transition).
export const RESIZE_DEBOUNCE_MS = ENTERING_SCREEN_MS + 35
